import type { PhaseType } from '@psl/flows/onboarding/functions/useOnboardingProgress';

export const isOnboardingPhaseInterruptible = (phase: PhaseType) => {
  if (phase === 'extra-info') return true;
  return false;
};
